import React, { useEffect } from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

const TopButton = (props) => {
  const [visible, setVisible] = React.useState(false);

  useEffect(() => {
    const scroller = () => {
      if (
        document.body.scrollTop > 20 ||
        document.documentElement.scrollTop > 20
      ) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", scroller);

    return () => {
      window.removeEventListener("scroll", scroller);
    };
  }, [visible]);

  return (
    <div>
      {visible ? (
        <button
          style={{
            boxShadow: "3px 3px 10px rgba(1, 1, 1, 0.5)",
          }}
          className="topbutton"
          onClick={() => {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            document.location.hash = "";
          }}
        >
          <ArrowUpwardIcon />
        </button>
      ) : null}
    </div>
  );
};
export default TopButton;
